import { env } from '@/env'
const urlencode = require('urlencode')
const appBaseURL = env.VUE_APP_BASE_URL
const redirectUri = `${appBaseURL}oidc-callback`
const popupRedirectUri = `${appBaseURL}oidc-popup-callback`
const silentRedirectUri = `${appBaseURL}silent-renew-oidc.html`
console.log('****BASE_URL', appBaseURL)
console.log('TEST')
const getAuthorityUri = () => {
  var subdomain
  if (!window.sessionStorage.getItem('authURL')) {
    try {
      console.log('ENTRY 045: getAuthorityUri, subdomain', subdomain)
      subdomain = urlencode.decode(window.location.href)
      subdomain = window.location.href.split('?url=')[1]
      subdomain = subdomain.replace('http://', '')
      subdomain = subdomain.replace('www.', '')
      subdomain = subdomain.replace('https://', '')
      subdomain = subdomain.split('.')[0]
      window.sessionStorage.setItem('authURL', subdomain)
      console.log('EXIT 045: getAuthorityUri, subdomain', subdomain)
    } catch (error) {
      console.log(
        'TAG 046: getAuthorityUri, VUE_APP_AUTH_URL',
        env.VUE_APP_AUTH_URL
      )
      return env.VUE_APP_AUTH_URL
    }
  } else {
    subdomain = window.sessionStorage.getItem('authURL')
  }

  if (env.VUE_APP_BASE_URL === 'https://ep-sandoweb.buildinglink.com/') {
    console.log(
      'TAG 047: getAuthorityUri, RETURN URL',
      `https://auth-${subdomain}.buildinglink.com`
    )
    return `https://auth-${subdomain}.buildinglink.com`
  } else {
    console.log(
      'TAG 048: getAuthorityUri, RETURN URL',
      `https://auth-${subdomain}.blkqa.com`
    )
    return `https://auth-${subdomain}.blkqa.com`
  }
}

export const oidcSettings = {
  authority: getAuthorityUri(),
  client_id: env.VUE_APP_AUTH_CLIENT_ID,
  redirect_uri: redirectUri,
  popup_redirect_uri: popupRedirectUri,
  responseType: 'id_token token',
  scope:
    'openid profile address phone email buildinglink internal_website_apis',
  post_logout_redirect_uri: appBaseURL,
  silent_redirect_uri: silentRedirectUri,
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  automaticSilentSignin: true,
  revokeAccessTokenOnSignout: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
}
